export default "__VITE_ASSET__OWD9E0lG__"